import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/admin/useAdminTicketsQuery.ts
var r = (r = {}) => t({
	queryKey: e.tickets(r),
	fetchPage: (e) => n.adminListTickets({
		...r,
		page: e
	}),
	key: "items"
});
//#endregion
export { r as useAdminTicketsQuery };
